(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kk-recent"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'kk_recently_viewed';
    var MAX_STORED = 12;

    function read() {
      try {
        var list = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    }

    function write(list) {
      try {
        localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED)));
      } catch (e) {}
    }

    function init(root) {
      root.querySelectorAll('[data-kk-recent]').forEach(setup);
    }

    function setup(section) {
      if (section.dataset.kkReady) return;
      section.dataset.kkReady = '1';

      var current = section.dataset.current;
      var limit = parseInt(section.dataset.limit, 10) || 4;
      var list = read();

      // Show what was viewed before this page, then remember this product at the front.
      var handles = list.filter(function (h) { return h !== current; }).slice(0, limit);
      if (current) write([current].concat(list.filter(function (h) { return h !== current; })));
      if (!handles.length) return;

      var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      Promise.all(handles.map(function (h) {
        return fetch(root_url + 'products/' + encodeURIComponent(h) + '?view=kk-card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (cards) {
        var grid = section.querySelector('[data-kk-recent-grid]');
        var gone = [];
        cards.forEach(function (html, i) {
          if (html.indexOf('kk-card') === -1) { gone.push(handles[i]); return; }
          grid.insertAdjacentHTML('beforeend', html);
        });
        // Forget products that no longer exist.
        if (gone.length) write(read().filter(function (h) { return gone.indexOf(h) === -1; }));
        // Cards fetched after load would otherwise stay hidden by the scroll-reveal styles.
        grid.querySelectorAll('.kk-rv').forEach(function (el) { el.classList.remove('kk-rv'); });
        if (grid.children.length) section.hidden = false;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else { init(document); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
